import { get, merge } from 'lodash'
import deepFreeze from 'deep-freeze'
import { exposeToWindow } from 'utils/exposeToWindow'

/**
 * Default config values which can be change on deployed environments.
 */
const defaultConfig = {
  API_BASE_URL: 'qa-1.qa.willsubplus.com',
}

/*
  Returns portal application url with protocol without current sub domain
  Current application should be hosted on URL with sub domain.
  For development mode will be used QA env.
  Example, current hostname: signup.qa-1.willsubplus.com
  Result: qa-1.willsubplus.com
 */
const setApiBaseUrl = () => {
  const { hostname } = window.location

  const hostnameSplited = hostname.split('.')

  hostnameSplited.shift()
  const hostNameWithoutDomain = hostnameSplited.join('.')

  if (!hostname.match('localhost')) {
    defaultConfig.API_BASE_URL = hostNameWithoutDomain
  }
}

setApiBaseUrl()

/**
 * Calculated effectiveConfig based on the env
 */
const effectiveConfig = deepFreeze(merge(defaultConfig, get(window, 'ORION.env', {})))

exposeToWindow('config', effectiveConfig)

export const config = effectiveConfig
